// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface CatalogPrice {
  productPriceId: string;
  amount: number;
  productItemId: string;
  currencyCode: string;
  currencySymbol: string;
  countryISOCode: string;
  productType: string;
  liableForTax: boolean;
}

export interface S12nDerivativesV1 {
  id: string;
  averageFiveStarRating?: number | null;
  ratingCount?: number | null;
  catalogPrice?: CatalogPrice | null;
  avgLearningHoursAdjusted?: number | null;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface S12nDerivativesV1Connection {
  elements: Array<S12nDerivativesV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface S12nDerivativesV1GetQuery {
  S12nDerivativesV1: {
    get: S12nDerivativesV1Connection | null;
  } | null;
}

export interface S12nDerivativesV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface S12nDerivativesV1MultiGetQuery {
  S12nDerivativesV1: {
    multiGet: S12nDerivativesV1Connection | null;
  } | null;
}

export interface S12nDerivativesV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class S12nDerivativesV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 's12nDerivatives.v1' as const;

  declare id: string;

  declare averageFiveStarRating?: number | null;

  declare ratingCount?: number | null;

  declare catalogPrice?: CatalogPrice | null;

  declare avgLearningHoursAdjusted?: number | null;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<S12nDerivativesV1>) {
    super(params);
  }
}
